import React, { useEffect, useState } from "react";
import  'bootstrap/dist/css/bootstrap.min.css' ;
import { Row, Col } from "react-bootstrap";
import { FcKey, FcVoicePresentation } from "react-icons/fc";
import ImgPartSocial from "../../assets/participacao-social.png";
import "./styles.css";
import Perfil from "./../../tools/Perfil";

export default function Painel({ history }) {
  const [msgIdent,setMsgIdent] = useState("Clique aqui para se identificar");
  const NomeParticipante = localStorage.getItem("NomeParticipante");
  const [modalShow, setModalShow] = useState(false);

  useEffect(() => {
    async function loadPessoa() {
      if (NomeParticipante) {
        setMsgIdent("Clique aqui para sair");
      }
    }
    loadPessoa();
  }, [NomeParticipante]);

  function handleClickIdentificacao() {
    console.log(NomeParticipante);
    if (NomeParticipante){
      setModalShow(true);
    }
    else{
      window.location = "/Login";
    }
  }

  return (
    <>
      <Row>
        <Col sm={12} className="barraInicial">
                <a href="/"><img className="imagemInicial" src={ImgPartSocial} alt="Figura Participacao Social na ANA" /></a>
        </Col>
      </Row>
      <div className="Cabecalho">
        <Row>
          <Col sm="8" className="Aponta" onClick={() => window.location.href="/"}>
            <strong>Sistema de Participação Social nas Decisões da ANA</strong>
          </Col>
          <Col sm="4">
            <div>
                <Perfil 
                  id="Perfil"
                  show={modalShow} 
                  onHide={() => setModalShow(false)} />
                <label className="Aponta" 
                    onClick={handleClickIdentificacao}
                    data-toggle="tooltip"
                    title={msgIdent} 
                >
                    <span className="icone">{ NomeParticipante ? <FcVoicePresentation /> : <FcKey /> }</span>
                    &nbsp;
                    { NomeParticipante ? NomeParticipante : "Clique aqui para se identificar"}
                </label>
                <span className="ambiente">
                  
                </span>
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
}
